<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customerForm.actions.reopen.title')"
    :info="info"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { CustomerForm } from '~/_api/models/customerForm'
import type { Customer } from '~/_api/models/customer'

interface Props {
  customerForm: CustomerForm
  customer: Customer
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()

const info = computed(() => {
  return $i18n.t('components.customerForm.actions.reopen.info', { title: (props.customerForm as any).form.title, name: props.customer.displayName })
})

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.customerForm.reopen(props.customerForm.objectID()!)

    if (response.success) {
      emit('success')
      $notification.toast({
        title: $i18n.t('components.customerForm.actions.reopen.success'),
        text: $i18n.t('components.customerForm.actions.reopen.successInfo', { title: (props.customerForm as any).form.title, name: props.customer.displayName }),
      })
      return true
    }
  } catch (e) {
    emit('error')
    $notification.toast({
      title: $i18n.t('general.error'),
      text: $i18n.t('components.customerForm.actions.reopen.errorInfo', { title: (props.customerForm as any).form.title, name: props.customer.displayName }),
    })
  }
}

defineExpose({ open })
</script>
